{
  "actionbar.actions": "الإجراءات",
  "actionbar.actionsAvailable": "الإجراءات المتاحة.",
  "actionbar.clearSelection": "إزالة التحديد",
  "actionbar.selected": "{count, plural, =0 {غير محدد} other {# محدد}}",
  "actionbar.selectedAll": "تم تحديد الكل",
  "breadcrumbs.more": "المزيد من العناصر",
  "button.pending": "قيد الانتظار",
  "calendar.invalidSelection": "{selectedCount, plural, one {التاريخ} other {التواريخ}} المحدد/المحددة غير متوفرة.",
  "combobox.noResults": "لا توجد نتائج",
  "contextualhelp.help": "مساعدة",
  "contextualhelp.info": "معلومات",
  "datepicker.endTime": "وقت الانتهاء",
  "datepicker.startTime": "وقت البدء",
  "datepicker.time": "الوقت",
  "dialog.alert": "تنبيه",
  "dialog.dismiss": "تجاهل",
  "dropzone.replaceMessage": "للاستبدال، قم بإفلات الملف",
  "inlinealert.informative": "معلومات",
  "inlinealert.negative": "خطأ",
  "inlinealert.notice": "تحذير",
  "inlinealert.positive": "تم بنجاح",
  "label.(optional)": "(اختياري)",
  "label.(required)": "(مطلوب)",
  "menu.moreActions": "المزيد من الإجراءات",
  "notificationbadge.indicatorOnly": "نشاط جديد",
  "notificationbadge.plus": "{notifications}+",
  "picker.placeholder": "تحديد…",
  "slider.maximum": "أقصى",
  "slider.minimum": "أدنى",
  "table.loading": "جارٍ التحميل...",
  "table.loadingMore": "جارٍ تحميل المزيد...",
  "table.resizeColumn": "تغيير حجم العمود",
  "table.sortAscending": "فرز بترتيب تصاعدي",
  "table.sortDescending": "فرز بترتيب تنازلي",
  "tag.actions": "الإجراءات",
  "tag.hideButtonLabel": "إظهار أقل",
  "tag.noTags": "بدون",
  "tag.showAllButtonLabel": "عرض الكل ({tagCount, number})",
  "toast.clearAll": "مسح الكل",
  "toast.collapse": "طي",
  "toast.showAll": "إظهار الكل"
}
